import React, { useContext } from 'react';
import { AuthContext } from '../App';
import { Sparkles } from 'lucide-react';

const FreeCreditsBanner = () => {
  const { user, openAuth } = useContext(AuthContext);
  
  // Only show for unauthenticated users
  if (user) return null;
  
  return (
    <div className="bg-gradient-to-r from-blue-700 to-blue-800 text-white py-2 px-4 sticky top-14 z-40">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3">
        <div className="flex items-center justify-between md:justify-center gap-2 md:gap-3 w-full md:w-auto">
          <Sparkles className="h-4 w-4 md:h-5 md:w-5 animate-pulse flex-shrink-0" />
          <p className="text-sm font-semibold text-left flex-1 md:flex-initial leading-tight">
            Create an Account &<br className="md:hidden" /> Get 30 AI Credits Free!
          </p>
          <button
            onClick={() => openAuth('register')}
            className="bg-white text-orange-600 hover:bg-gray-100 px-3 md:px-4 py-1 rounded-md text-sm font-bold transition-colors whitespace-nowrap flex-shrink-0"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeCreditsBanner;
